import React, { Fragment } from "react";
import { Field, FieldArray, useFormikContext } from "formik";
import { v4 as uuid } from "uuid";
import Label from "components/FormElements/Label";
import TextInput from "components/FormElements/TextInput";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { PlusIcon, TrashIcon } from "@heroicons/react/outline";

export default function MetaField(props) {
    const { values } = useFormikContext();

    return (
        <div>
            <div className="pb-2">
                <Label>Meta Properties</Label>
            </div>
            <FieldArray name="metadata">
                {({ insert, remove, push }) => (
                    <div className="space-y-4">
                        {values.metadata?.length > 0 &&
                            values.metadata.map((item, index) => (
                                <div
                                    key={index}
                                    className="flex items-end space-x-4"
                                >
                                    <TextInput
                                        name={`metadata.${index}.label`}
                                        placeholder="Label"
                                        type="text"
                                        label={index === 0 ? "Label" : null}
                                    />
                                    <div className="flex-grow">
                                        <TextInput
                                            name={`metadata.${index}.value`}
                                            type="text"
                                            placeholder="Value"
                                            label={index === 0 ? "Value" : null}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        className="secondary"
                                        onClick={() => remove(index)}
                                    >
                                        <TrashIcon className="h-5 w-5 md:mb-3" />
                                    </button>
                                    <Field
                                        name={`metadata.${index}.id`}
                                        type="hidden"
                                    />
                                </div>
                            ))}
                        <SecondaryButton
                            type="button"
                            className="flex"
                            onClick={() =>
                                push({
                                    id: uuid(),
                                    label: "",
                                    value: "",
                                })
                            }
                            label={
                                <Fragment>
                                    <PlusIcon className="mt-0.5 mr-1 h-4 w-4" />
                                    Add Meta Property
                                </Fragment>
                            }
                        />
                    </div>
                )}
            </FieldArray>
        </div>
    );
}
